export { default as CategoriesIndexPageHeader } from './CategoriesIndexPageHeader';
